<div class="modal-header">
  <h4 class="modal-title">Info</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p>{{ infoMessage }}</p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
